import React, { useEffect, useState } from 'react';
import { useEducation } from '../../context/educationContext';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Modal from '../../components/modal';

const Schools = () => {
  const { listSchoolUnits } = useEducation();
  const [localSchoolUnits, setLocalSchoolUnits] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchSchools = async () => {
      const schools = await listSchoolUnits();
      if (schools) setLocalSchoolUnits(schools.results);
    };
    fetchSchools();
  }, [listSchoolUnits]);

  const handleViewSchool = async (schoolId) => {
    try {
      const school = localSchoolUnits.find((s) => s.id === schoolId);
      if (school) {
        setSelectedSchool(school);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Erro ao carregar dados da escola:', error);
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo children={<h2>Escolas cadastradas</h2>} />
        <div className="content content-table">
          <table className="school-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Cidade</th>
                <th>Telefone</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {localSchoolUnits.map((school) => (
                <tr key={school.id}>
                  <td>{school.name}</td>
                  <td>{school.city_name}</td>
                  <td>{school.phone}</td>
                  <td>{school.email}</td>
                  <td>
                    <button onClick={() => handleViewSchool(school.id)} className="action-button">
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {localSchoolUnits.length === 0 && (
            <p style={{ textAlign: 'center', marginTop: '20px' }}>
              Nenhuma escola cadastrada.
            </p>
          )}
        </div>

        {/* Usando Modal para exibir os dados da escola em formulário readonly */}
        <Modal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          title={selectedSchool ? `Escola: ${selectedSchool.name}` : ''}
        >
          {selectedSchool && (
            <form>

              <div className="form-group-large">
                <label>Nome</label>
                <input type="text" value={selectedSchool.name} readOnly />
              </div>
              <div className="form-group">
                <label>Cidade</label>
                <input type="text" value={selectedSchool.city_name} readOnly />
              </div>
              <div className="form-group">
                <label>Estado</label>
                <input type="text" value={selectedSchool.state} readOnly />
              </div>
              <div className="form-group">
                <label>Bairro</label>
                <input type="text" value={selectedSchool.neighborhood} readOnly />
              </div>
              <div className="form-group">
                <label>CEP</label>
                <input type="text" value={selectedSchool.cep} readOnly />
              </div>

              <div className="form-group-large">
                <label>Endereço</label>
                <input type="text" value={`${selectedSchool.public_place}, ${selectedSchool.complement}`} readOnly />
              </div>

              <div className="form-group">
                <label>Telefone</label>
                <input type="text" value={selectedSchool.phone} readOnly />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="text" value={selectedSchool.email} readOnly />
              </div>

            </form>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Schools;